// src/config/auth.js
export const login = (token) => {
  localStorage.setItem("auth_token", token);
};

export const logout = () => {
  localStorage.removeItem("auth_token");
};

export const isAuthenticated = async (token) => {
  if (!token) {
    return false; // No token present
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/users/service-api/v1/users/find-user`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      return true; // Token is valid
    }
    return false; // Token is invalid
  } catch (error) {
    return false; // Handle any error, like network issues
  }
};
